import { render, staticRenderFns } from "./ProjectSelector.vue?vue&type=template&id=72ab6cad&scoped=true"
import script from "./ProjectSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectSelector.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProjectSelector.vue?vue&type=style&index=0&id=72ab6cad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ab6cad",
  null
  
)

export default component.exports